export default "__VITE_ASSET__CjH0B4Vq__"